import { render, staticRenderFns } from "./jushuitan_after_sales.vue?vue&type=template&id=7aeedaf2"
import script from "./jushuitan_after_sales.vue?vue&type=script&lang=js"
export * from "./jushuitan_after_sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports